<template>
  <div class="income-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2 class="page-title">
        <i class="el-icon-medal"></i>
        兼职收入排行榜
      </h2>
      <p class="page-subtitle">总收益可查看本校全部队长与普通兼职；团队收益可查看队长名下兼职收益</p>
    </div>

    <!-- 实时统计卡片：总收入、日收入、当前账户金额 -->
    <el-row :gutter="24" class="stats-row">
      <el-col :xs="24" :sm="12" :md="6">
        <div class="stat-card">
          <div class="stat-icon" style="background: linear-gradient(135deg, #1890ff, #096dd9);">
            <i class="el-icon-money"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">总收入</div>
            <div class="stat-value">￥{{ formatMoney(stats.totalIncome) }}</div>
            <div class="stat-desc">当前筛选日期与学校范围内，队长提成与普通兼职收益合计</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="6">
        <div class="stat-card">
          <div class="stat-icon" style="background: linear-gradient(135deg, #faad14, #d48806);">
            <i class="el-icon-timer"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">日收入</div>
            <div class="stat-value">￥{{ formatMoney(stats.dayIncome) }}</div>
            <div class="stat-desc">筛选日期范围内最后一天（单日则为该日）在所选学校内的总收入</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="6">
        <div class="stat-card">
          <div class="stat-icon" style="background: linear-gradient(135deg, #722ed1, #531dab);">
            <i class="el-icon-wallet"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">当前账户金额</div>
            <div class="stat-value">￥{{ formatMoney(stats.totalBalance) }}</div>
            <div class="stat-desc">当前全平台所有队长/普通兼职的可提现余额总和</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-card class="table-card">
      <div slot="header" class="card-header">
        <span><i class="el-icon-data-line"></i> 收入排行详情</span>
        <div class="card-actions">
          <!-- 时间范围筛选（全局） -->
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
            style="width: 260px; margin-right: 12px;"
            @change="onDateRangeChange">
          </el-date-picker>
          <!-- 学校筛选 -->
          <el-select
            v-model="selectedSchool"
            :placeholder="schoolLocked ? '本校' : '全部学校'"
            :clearable="!schoolLocked"
            :disabled="schoolLocked"
            size="small"
            style="width: 220px; margin-right: 12px;"
          >
            <el-option
              v-for="item in schoolOptions"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
          <!-- 角色筛选：仅总收益 -->
          <el-select
            v-if="rankView === 'total'"
            v-model="selectedRole"
            placeholder="全部角色"
            clearable
            size="small"
            style="width: 140px; margin-right: 12px;">
            <el-option label="队长" value="F" />
            <el-option label="普通兼职" value="C" />
          </el-select>
          <!-- 姓名搜索 -->
          <el-input
            v-model="searchName"
            :placeholder="rankView === 'team' ? '搜索队长/团队姓名' : '搜索队长/兼职姓名'"
            prefix-icon="el-icon-search"
            clearable
            size="small"
            style="width: 220px; margin-right: 12px;"
            @clear="loadData"
            @keyup.enter.native="loadData">
          </el-input>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="handleSearch"
            style="background:#00C2A8;border-color:#00C2A8;">
            搜索
          </el-button>
          <el-button 
            type="primary" 
            size="small" 
            icon="el-icon-refresh" 
            @click="handleSearch"
            :loading="loading"
            style="background:#00C2A8;border-color:#00C2A8;">
            刷新数据
          </el-button>
        </div>
      </div>

      <el-tabs v-model="rankView" class="rank-tabs">
        <el-tab-pane label="总收益" name="total">
          <el-table
            :data="filteredTotalList"
            style="width: 100%"
            v-loading="loading"
            :default-sort="{prop: 'income', order: 'descending'}">
            <el-table-column type="index" label="排名" width="100" align="center">
              <template slot-scope="scope">
                <div v-if="scope.$index === 0" class="rank-badge rank-1">
                  <i class="el-icon-medal"></i>
                  <span>冠军</span>
                </div>
                <div v-else-if="scope.$index === 1" class="rank-badge rank-2">
                  <i class="el-icon-medal"></i>
                  <span>亚军</span>
                </div>
                <div v-else-if="scope.$index === 2" class="rank-badge rank-3">
                  <i class="el-icon-medal"></i>
                  <span>季军</span>
                </div>
                <span v-else class="rank-normal">{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="jobName" label="姓名" min-width="180">
              <template slot-scope="scope">
                <div class="user-info">
                  <el-avatar :size="40" :src="scope.row.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'"></el-avatar>
                  <div class="user-details">
                    <div class="user-name">{{ scope.row.jobName }}</div>
                    <div class="user-phone">{{ scope.row.phone || '暂无手机号' }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="jobType" label="角色" width="120" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.jobType === 'F'" type="warning" size="small">队长</el-tag>
                <el-tag v-else size="small">普通兼职</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="schoolName" label="所属学校" min-width="150" align="center">
              <template slot-scope="scope">
                <el-tag type="info" size="medium">{{ scope.row.schoolName }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="teamName" label="所属团队" min-width="140" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.jobType === 'F'">—</span>
                <span v-else-if="scope.row.teamName">{{ scope.row.teamName }}</span>
                <span v-else class="user-phone">自主兼职</span>
              </template>
            </el-table-column>

            <el-table-column prop="income" label="总收入" min-width="150" align="right" sortable>
              <template slot-scope="scope">
                <div class="income-cell">
                  <span class="income-amount">￥{{ (scope.row.income || 0).toFixed(2) }}</span>
                  <el-progress
                    :percentage="getPercentage(scope.row.income || 0)"
                    :color="getProgressColor(scope.$index)"
                    :show-text="false"
                    class="income-progress">
                  </el-progress>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="120" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="viewDetails(scope.row)"
                  style="color: #00C2A8;">
                  <i class="el-icon-view"></i> 查看详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="!loading && filteredTotalList.length === 0" class="empty-state">
            <i class="el-icon-folder-opened"></i>
            <p>暂无收入数据</p>
          </div>
        </el-tab-pane>

        <el-tab-pane label="团队收益" name="team">
          <el-table
            :data="filteredTeamList"
            style="width: 100%"
            v-loading="loading"
            :default-sort="{prop: 'teamIncome', order: 'descending'}">
            <el-table-column type="index" label="排名" width="100" align="center">
              <template slot-scope="scope">
                <div v-if="scope.$index === 0" class="rank-badge rank-1">
                  <i class="el-icon-medal"></i>
                  <span>冠军</span>
                </div>
                <div v-else-if="scope.$index === 1" class="rank-badge rank-2">
                  <i class="el-icon-medal"></i>
                  <span>亚军</span>
                </div>
                <div v-else-if="scope.$index === 2" class="rank-badge rank-3">
                  <i class="el-icon-medal"></i>
                  <span>季军</span>
                </div>
                <span v-else class="rank-normal">{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="jobName" label="队长/团队" min-width="180">
              <template slot-scope="scope">
                <div class="user-info">
                  <el-avatar :size="40" :src="scope.row.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'"></el-avatar>
                  <div class="user-details">
                    <div class="user-name">{{ scope.row.jobName }}</div>
                    <div class="user-phone">{{ scope.row.phone || '暂无手机号' }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="schoolName" label="所属学校" min-width="150" align="center">
              <template slot-scope="scope">
                <el-tag type="info" size="medium">{{ scope.row.schoolName }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="memberCount" label="名下兼职" width="110" align="center">
              <template slot-scope="scope">
                {{ scope.row.memberCount || 0 }} 人
              </template>
            </el-table-column>

            <el-table-column prop="teamIncome" label="团队兼职收益" min-width="160" align="right" sortable>
              <template slot-scope="scope">
                <div class="income-cell">
                  <span class="income-amount">￥{{ (scope.row.teamIncome || 0).toFixed(2) }}</span>
                  <el-progress
                    :percentage="getTeamPercentage(scope.row.teamIncome || 0)"
                    :color="getProgressColor(scope.$index)"
                    :show-text="false"
                    class="income-progress">
                  </el-progress>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="220" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="viewTeamMembers(scope.row)"
                  style="color: #00C2A8;">
                  <i class="el-icon-s-custom"></i> 查看兼职收益
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="viewDetails(scope.row)"
                  style="color: #00C2A8;">
                  <i class="el-icon-view"></i> 查看详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="!loading && filteredTeamList.length === 0" class="empty-state">
            <i class="el-icon-folder-opened"></i>
            <p>暂无团队收益数据</p>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 详情对话框 -->
    <el-dialog 
      :title="detailDialogTitle" 
      :visible.sync="detailDialogVisible" 
      width="80%"
      top="5vh"
      :close-on-click-modal="false">
      <div v-loading="detailLoading">
        <!-- 基本信息卡片 -->
        <el-card class="detail-info-card" shadow="never">
          <el-row :gutter="24">
            <el-col :span="6">
              <div class="info-item">
                <span class="info-label">负责人/团队：</span>
                <span class="info-value">{{ currentDetail.jobName }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="info-item">
                <span class="info-label">所属学校：</span>
                <span class="info-value">{{ currentDetail.schoolName }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="info-item">
                <span class="info-label">订单总数：</span>
                <span class="info-value">{{ filteredDetailOrders.length }} 笔</span>
              </div>
            </el-col>
          </el-row>
          <!-- 单人实时金额：总收入、日收入、当前账户金额 -->
          <el-row :gutter="24" style="margin-top: 16px;">
            <el-col :span="6">
              <div class="info-item">
                <span class="info-label">总收入：</span>
                <span class="info-value income-highlight">￥{{ formatMoney(detailStats.totalIncome) }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="info-item">
                <span class="info-label">时间范围：</span>
                <span class="info-value" style="color:#909399;">
                  {{ (detailDateRange && detailDateRange.length===2) ? (detailDateRange[0] + ' 至 ' + detailDateRange[1]) : '全部' }}
                </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="info-item">
                <span class="info-label">日收入：</span>
                <span class="info-value">￥{{ formatMoney(detailStats.dayIncome) }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="info-item">
                <span class="info-label">当前账户金额：</span>
                <span class="info-value income-highlight">￥{{ formatMoney(detailStats.totalBalance) }}</span>
              </div>
            </el-col>
          </el-row>
        </el-card>

        <!-- 订单列表 -->
        <el-card class="detail-orders-card" shadow="never" style="margin-top: 20px;">
          <div slot="header" style="display: flex; align-items: center; justify-content: space-between;">
            <span><i class="el-icon-document"></i> 订单明细</span>
            <div>
              <!-- 详情时间范围筛选 -->
              <el-date-picker
                v-model="detailDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                size="small"
                style="width: 260px; margin-right: 12px;"
                @change="onDetailDateRangeChange">
              </el-date-picker>
              <!-- 订单号搜索 -->
              <el-input
                v-model="detailSearchText"
                placeholder="搜索订单号"
                prefix-icon="el-icon-search"
                size="small"
                style="width: 260px;"
                clearable>
              </el-input>
            </div>
          </div>
          
          <el-table 
            :data="pagedDetailOrders" 
            style="width: 100%"
            max-height="450">
            <el-table-column type="index" label="序号" width="60" align="center">
              <template slot-scope="scope">
                {{ (detailPageNum - 1) * detailPageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="orderId" label="订单号" min-width="180">
              <template slot-scope="scope">
                <span style="color: var(--primary-color);">{{ scope.row.orderId || scope.row.id }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="订单类型" width="120">
              <template slot-scope="scope">
                <el-tag size="small" type="primary">{{ scope.row.type || scope.row.orderType || '未知' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="orderPrice" label="订单金额" width="120" align="right">
              <template slot-scope="scope">
                <span style="color: #00C2A8; font-weight: 600;">￥{{ (scope.row.orderPrice != null ? scope.row.orderPrice : 0).toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="profit" label="收益金额" width="120" align="right">
              <template slot-scope="scope">
                <span style="color: #f56c6c; font-weight: 600;">￥{{ (scope.row.profit != null ? scope.row.profit : 0).toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                {{ scope.row.createTime | dateFormat }}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status == '0'" type="info" size="small">待接单</el-tag>
                <el-tag v-else-if="scope.row.status == '1'" type="warning" size="small">进行中</el-tag>
                <el-tag v-else-if="scope.row.status == '2'" type="success" size="small">已完成</el-tag>
                <el-tag v-else type="danger" size="small">已取消</el-tag>
              </template>
            </el-table-column>
          </el-table>

          <!-- 订单列表空状态 -->
          <div v-if="!detailLoading && filteredDetailOrders.length === 0" class="empty-state">
            <i class="el-icon-document"></i>
            <p>{{ detailSearchText ? '未找到匹配的订单' : '暂无订单数据' }}</p>
          </div>

          <!-- 分页器 -->
          <el-pagination
            v-if="filteredDetailOrders.length > 0"
            @size-change="handleDetailSizeChange"
            @current-change="handleDetailPageChange"
            :current-page="detailPageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="detailPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="filteredDetailTotal"
            style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="exportDetail" style="background:#00C2A8;border-color:#00C2A8;">
          <i class="el-icon-download"></i> 导出数据
        </el-button>
      </span>
    </el-dialog>

    <!-- 团队名下兼职收益 -->
    <el-dialog
      :title="teamMemberDialogTitle"
      :visible.sync="teamMemberDialogVisible"
      width="70%"
      top="8vh"
      :close-on-click-modal="false">
      <el-table
        :data="currentTeamMembers"
        style="width: 100%"
        max-height="520"
        :default-sort="{prop: 'income', order: 'descending'}">
        <el-table-column type="index" label="排名" width="80" align="center" />
        <el-table-column prop="jobName" label="兼职姓名" min-width="180">
          <template slot-scope="scope">
            <div class="user-info">
              <el-avatar :size="36" :src="scope.row.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'"></el-avatar>
              <div class="user-details">
                <div class="user-name">{{ scope.row.jobName }}</div>
                <div class="user-phone">{{ scope.row.phone || '暂无手机号' }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="schoolName" label="所属学校" min-width="140" align="center">
          <template slot-scope="scope">
            <el-tag type="info" size="small">{{ scope.row.schoolName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="income" label="兼职收益" min-width="140" align="right" sortable>
          <template slot-scope="scope">
            <span class="income-amount">￥{{ (scope.row.income || 0).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="viewDetails(scope.row)"
              style="color: #00C2A8;">
              <i class="el-icon-view"></i> 查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="currentTeamMembers.length === 0" class="empty-state">
        <i class="el-icon-user"></i>
        <p>该团队暂无名下兼职</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="teamMemberDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { isSchoolScoped, getBoundSchoolName, applySchoolQuery } from '@/utils/schoolScope'
export default {
  name: 'ParttimeIncome',
  data() {
    return {
      loading: false,
      searchName: '',
      selectedSchool: '', // 学校筛选
      schoolOptions: [],  // 学校下拉选项
      dateRange: [],      // 排行榜时间范围（按日）
      rankView: 'total',  // total=总收益, team=团队收益
      selectedRole: '',   // F=队长, C=普通兼职
      incomeList: [],
      leaderList: [],
      parttimeList: [],
      // 实时统计：总收入、月收入、日收入、当前账户金额
      stats: {
        totalIncome: 0,
        dayIncome: 0,
        totalBalance: 0
      },
      // 当前查看详情时的单人实时统计
      detailStats: {
        totalIncome: 0,
        dayIncome: 0,
        totalBalance: 0
      },
      // 详情对话框相关
      detailDialogVisible: false,
      detailLoading: false,
      currentDetail: {},
      detailOrders: [],
      detailSearchText: '',
      detailDateRange: [], // 详情弹窗订单时间范围
      // 详情对话框分页
      detailPageNum: 1,
      detailPageSize: 10,
      // 团队名下兼职
      teamMemberDialogVisible: false,
      currentTeam: {},
      currentTeamMembers: [],
    };
  },
  watch: {
    // 监听搜索框变化，自动重置到第一页
    detailSearchText() {
      this.detailPageNum = 1;
    }
  },
  computed: {
    schoolLocked() {
      return isSchoolScoped();
    },
    // 按学校 + 姓名 + 角色过滤后的总收益（本校全部队长、普通兼职）
    filteredTotalList() {
      return this.applyCommonFilters(this.incomeList).filter(item => {
        if (!this.selectedRole) return true;
        return item.jobType === this.selectedRole;
      });
    },
    // 团队收益：按队长列出，金额为名下兼职收益合计
    filteredTeamList() {
      const leaders = this.applyCommonFilters(this.leaderList);
      return leaders
        .map(leader => {
          const members = this.getTeamMembers(leader);
          return {
            ...leader,
            memberCount: members.length,
            teamIncome: members.reduce((sum, item) => sum + (item.income || 0), 0)
          };
        })
        .sort((a, b) => (b.teamIncome || 0) - (a.teamIncome || 0));
    },
    totalIncome() {
      if (!Array.isArray(this.incomeList)) return 0;
      return this.incomeList.reduce((sum, item) => sum + (item.income || 0), 0);
    },
    topIncome() {
      if (!Array.isArray(this.incomeList) || this.incomeList.length === 0) return 0;
      return Math.max(...this.incomeList.map(item => item.income || 0));
    },
    topTeamIncome() {
      const list = this.filteredTeamList || [];
      if (!list.length) return 0;
      return Math.max(...list.map(item => item.teamIncome || 0));
    },
    detailDialogTitle() {
      return `${this.currentDetail.jobName || ''} - 收入详情`;
    },
    teamMemberDialogTitle() {
      return `${this.currentTeam.jobName || ''} - 名下兼职收益`;
    },
    // 搜索过滤后的订单
    filteredDetailOrders() {
      let orders = this.detailOrders || [];

      // 按订单号搜索
      if (this.detailSearchText) {
        orders = orders.filter(order => {
          const orderId = order.orderId || order.id || '';
          return orderId.toString().toLowerCase().includes(this.detailSearchText.toLowerCase());
        });
      }

      // 按时间范围过滤
      if (this.detailDateRange && this.detailDateRange.length === 2) {
        const [start, end] = this.detailDateRange;
        const startTime = new Date(start + ' 00:00:00').getTime();
        const endTime = new Date(end + ' 23:59:59').getTime();
        orders = orders.filter(order => {
          const ct = order.createTime ? new Date(order.createTime).getTime() : NaN;
          return !isNaN(ct) && ct >= startTime && ct <= endTime;
        });
      }

      return orders;
    },
    // 当前页显示的订单（分页后）
    pagedDetailOrders() {
      const filtered = this.filteredDetailOrders;
      const start = (this.detailPageNum - 1) * this.detailPageSize;
      const end = start + this.detailPageSize;
      return filtered.slice(start, end);
    },
    // 过滤后的总数
    filteredDetailTotal() {
      return this.filteredDetailOrders.length;
    }
  },
  created() {
    if (isSchoolScoped()) {
      this.selectedSchool = getBoundSchoolName();
    }
    this.loadStats();
    this.loadData();
  },
  methods: {
    formatMoney(val) {
      const n = parseFloat(val);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    applyCommonFilters(list) {
      let result = Array.isArray(list) ? list : [];
      if (this.selectedSchool) {
        result = result.filter(item => item.schoolName === this.selectedSchool);
      }
      if (this.searchName && this.searchName.trim()) {
        const keyword = this.searchName.trim().toLowerCase();
        result = result.filter(item => {
          const name = (item.jobName || '').toLowerCase();
          const phone = (item.phone || '').toString();
          const teamName = (item.teamName || '').toLowerCase();
          return name.includes(keyword) || phone.includes(keyword) || teamName.includes(keyword);
        });
      }
      return result;
    },
    isTeamMember(parttime, leaderId) {
      const parentId = Number(parttime && parttime.jobParentId);
      const uid = Number(leaderId);
      return !!uid && !!parentId && parentId === uid;
    },
    getTeamMembers(leader) {
      const leaderId = leader && leader.campusUserId;
      if (!leaderId) return [];
      return (this.parttimeList || [])
        .filter(item => this.isTeamMember(item, leaderId))
        .slice()
        .sort((a, b) => (b.income || 0) - (a.income || 0));
    },
    viewTeamMembers(row) {
      this.currentTeam = row || {};
      this.currentTeamMembers = this.getTeamMembers(row);
      this.teamMemberDialogVisible = true;
    },
    formatIncomeItem(item, index, fallbackJobType) {
      if (Array.isArray(item)) {
        return {
          id: index + 1,
          jobName: item[0] || '未知',
          schoolName: item[1] || '未知',
          income: parseFloat(item[2]) || 0,
          phone: item[3] || '',
          avatar: item[4] || '',
          campusUserId: item[5] || null,
          jobType: fallbackJobType || '',
          jobParentId: 0,
          teamName: ''
        };
      }

      const extractValue = (field) => {
        if (field === undefined || field === null || field === '') {
          return null;
        }
        if (Array.isArray(field) && field.length >= 2) {
          return field[1];
        }
        return field;
      };

      let incomeValue = item.totalAmount != null ? item.totalAmount : (extractValue(item.total) || extractValue(item.income) || extractValue(item.totalIncome) || extractValue(item.money) || extractValue(item.amount));
      let income = parseFloat(incomeValue) || 0;
      if (isNaN(income)) income = 0;

      const jobType = item.jobType || fallbackJobType || '';
      const jobParentId = item.jobParentId != null ? item.jobParentId : 0;
      return {
        id: index + 1,
        jobName: (item.jpUserName && item.jpUserName.trim()) ? item.jpUserName.trim() : (item.jpNickName || item.jobName || item.name || item.nickName || '未知'),
        schoolName: item.schoolName || item.school || '未知',
        income: income,
        phone: item.phone || item.jobPhone || item.phoneNumber || item.jpPhone || '',
        avatar: item.avatar || item.jpPortrait || '',
        campusUserId: item.campusUserId || null,
        jobType,
        jobParentId,
        teamName: item.teamName || ''
      };
    },
    /** 搜索/刷新：按当前筛选条件重新加载（含时间范围） */
    handleSearch() {
      this.loadStats();
      this.loadData();
    },
    /** 全局时间范围变更（排行榜 + 统计） */
    onDateRangeChange() {
      // 变更时间后同时刷新统计和排行榜
      this.loadStats();
      this.loadData();
    },
    /** 加载实时统计：总收入、日收入、当前账户金额（支持全局时间范围） */
    async loadStats() {
      try {
        const params = {};
        // 如果选择了全局时间范围，则作为统计的开始/结束日期
        if (this.dateRange && this.dateRange.length === 2) {
          params.startDate = this.dateRange[0];
          params.endDate = this.dateRange[1];
        }
        const { data: res } = await this.$http.get('/init/getParttimeIncomeStats', { params });
        if (res.code === 200 && res.data) {
          this.stats = {
            totalIncome: res.data.totalIncome ?? 0,
            dayIncome: res.data.dayIncome ?? 0,
            totalBalance: res.data.totalBalance ?? 0
          };
        }
      } catch (e) {
        console.warn('loadStats error', e);
      }
    },
    async loadData() {
      this.loading = true;
      try {
        const params = {};
        // 学校筛选
        if (this.selectedSchool) params.schoolName = this.selectedSchool;
        if (isSchoolScoped()) {
          params.schoolName = getBoundSchoolName();
        }
        applySchoolQuery(params);
        // 时间范围筛选（按日）
        if (this.dateRange && this.dateRange.length === 2) {
          params.startDate = this.dateRange[0];
          params.endDate = this.dateRange[1];
        }
        const { data: res } = await this.$http.get('/init/getIncomeTotals', { params });
        console.log('===== 兼职收入接口返回 =====');
        console.log('完整响应:', JSON.stringify(res, null, 2));
        
        if (res.code === 200) {
          let rawData = res.data;
          let leaderRaw = [];
          let parttimeRaw = [];
          
          console.log('原始数据类型:', typeof rawData);
          console.log('是否为数组:', Array.isArray(rawData));
          
          if (rawData && typeof rawData === 'object' && !Array.isArray(rawData)) {
            console.log('数据结构键名:', Object.keys(rawData));
            leaderRaw = rawData.responsiblePerson || [];
            parttimeRaw = rawData.timeJobs || [];
            console.log('队长数据:', leaderRaw.length + '条');
            console.log('兼职数据:', parttimeRaw.length + '条');
          } else if (Array.isArray(rawData)) {
            leaderRaw = rawData;
          }
          
          this.leaderList = leaderRaw
            .filter(item => item && (typeof item === 'object' || Array.isArray(item)))
            .map((item, index) => this.formatIncomeItem(item, index, 'F'))
            .sort((a, b) => b.income - a.income);

          this.parttimeList = parttimeRaw
            .filter(item => item && (typeof item === 'object' || Array.isArray(item)))
            .map((item, index) => this.formatIncomeItem(item, index, 'C'))
            .sort((a, b) => b.income - a.income);

          this.incomeList = [...this.leaderList, ...this.parttimeList].sort((a, b) => b.income - a.income);
          
          const schools = new Set();
          this.incomeList.forEach(item => {
            if (item.schoolName) {
              schools.add(item.schoolName);
            }
          });
          this.schoolOptions = Array.from(schools);
          if (isSchoolScoped()) {
            const boundName = getBoundSchoolName();
            this.schoolOptions = boundName ? [boundName] : this.schoolOptions;
            this.selectedSchool = boundName || this.selectedSchool;
          }
          
          console.log('===== 最终处理结果 =====');
          console.log('总数据条数:', this.incomeList.length);
          console.log('队长条数:', this.leaderList.length);
          console.log('兼职条数:', this.parttimeList.length);
          
          if (this.incomeList.length > 0 && this.incomeList.every(item => item.income === 0)) {
            console.warn('警告：所有数据的收入都是0，可能是字段名不匹配');
            this.$message.warning('数据加载成功，但收入显示为0，请检查数据格式');
          }
          this.loadStats();
        } else {
          this.$message.error('加载数据失败：' + (res.msg || res.message || '未知错误'));
          this.incomeList = [];
          this.leaderList = [];
          this.parttimeList = [];
        }
      } catch (error) {
        console.error('加载收入数据失败:', error);
        console.error('错误详情:', error.response || error.message);
        this.$message.error('加载数据失败：' + (error.message || '请检查网络连接'));
        this.incomeList = [];
        this.leaderList = [];
        this.parttimeList = [];
      } finally {
        this.loading = false;
      }
    },
    getPercentage(income) {
      if (this.topIncome === 0) return 0;
      return Math.round((income / this.topIncome) * 100);
    },
    getTeamPercentage(income) {
      if (this.topTeamIncome === 0) return 0;
      return Math.round((income / this.topTeamIncome) * 100);
    },
    getProgressColor(index) {
      if (index === 0) return '#f56c6c';
      if (index === 1) return '#e6a23c';
      if (index === 2) return '#67c23a';
      return '#00C2A8';
    },
    async viewDetails(row) {
      console.log('===== 点击查看详情 =====');
      console.log('选中的数据:', row);
      
      // 设置当前详情数据
      this.currentDetail = {
        jobName: row.jobName || '未知',
        schoolName: row.schoolName || '未知',
        income: row.income || 0,
        phone: row.phone || '',
        avatar: row.avatar || '',
        campusUserId: row.campusUserId || null // 保存用户ID
      };
      
      console.log('设置 currentDetail:', this.currentDetail);
      
      // 清空之前的数据
      this.detailOrders = [];
      this.detailSearchText = '';
      this.detailPageNum = 1; // 重置到第一页
      this.detailPageSize = 10; // 重置每页条数
      this.detailStats = { totalIncome: 0, dayIncome: 0, totalBalance: 0 };
      // 默认继承页面的全局时间范围
      this.detailDateRange = (this.dateRange && this.dateRange.length === 2) ? [...this.dateRange] : [];

      // 打开对话框
      this.detailDialogVisible = true;
      console.log('对话框已打开: detailDialogVisible =', this.detailDialogVisible);

      const uid = row.campusUserId || this.currentDetail.campusUserId;
      if (uid) this.loadParttimeStatsByUser(uid);

      // 延迟加载订单详情，确保对话框先显示
      this.$nextTick(async () => {
        console.log('开始加载订单详情...');
        await this.loadOrderDetails(row);
        console.log('订单详情加载完成，detailOrders.length =', this.detailOrders.length);
      });
    },
    /** 详情弹窗订单时间范围变更 */
    onDetailDateRangeChange() {
      this.detailPageNum = 1;
      const uid = this.currentDetail.campusUserId;
      if (uid) this.loadParttimeStatsByUser(uid);
    },
    /** 加载单个兼职/负责人的实时统计（支持时间范围） */
    async loadParttimeStatsByUser(campusUserId) {
      if (!campusUserId) return;
      try {
        const params = { campusUserId };
        if (this.detailDateRange && this.detailDateRange.length === 2) {
          params.startDate = this.detailDateRange[0];
          params.endDate = this.detailDateRange[1];
        }
        const { data: res } = await this.$http.get('/init/getParttimeIncomeStatsByUser', { params });
        if (res.code === 200 && res.data) {
          this.detailStats = {
            totalIncome: res.data.totalIncome ?? 0,
            dayIncome: res.data.dayIncome ?? 0,
            totalBalance: res.data.totalBalance ?? 0
          };
        } else {
          this.detailStats = { totalIncome: 0, dayIncome: 0, totalBalance: 0 };
        }
      } catch (e) {
        console.warn('loadParttimeStatsByUser error', e);
        this.detailStats = { totalIncome: 0, dayIncome: 0, totalBalance: 0 };
      }
    },
    async loadOrderDetails(row) {
      this.detailLoading = true;
      console.log('===== 开始加载订单详情 =====');
      console.log('查询参数:', row);
      
      // 先立即生成模拟数据，确保对话框一定有内容
      const mockData = this.generateMockOrders(row);
      console.log('生成的模拟数据:', mockData.length + '条');
      
      try {
        let hasRealData = false;
        let orders = [];
        
        // 尝试方法1: 交易明细接口（使用 campusUserId 查询）
        try {
          console.log('尝试调用交易明细接口...');
          console.log('查询参数 - campusUserId:', row.campusUserId || this.currentDetail.campusUserId);
          
          // 构建查询参数
          let queryParams = {
            pageNum: 1,
            pageSize: 1000,
            timeout: 5000 // 5秒超时
          };
          
          // 优先使用 campusUserId 查询
          if (row.campusUserId || this.currentDetail.campusUserId) {
            queryParams.userId = row.campusUserId || this.currentDetail.campusUserId;
            console.log('✅ 使用 userId 精确查询:', queryParams.userId);
          } else {
            // 降级方案：使用姓名模糊查询（可能不准确）
            queryParams.jpNickName = row.jobName;
            queryParams.jobName = row.jobName;
            console.log('⚠️ 降级使用姓名查询:', row.jobName);
          }
          
          const { data: res1 } = await this.$http.get('/money/getCampusMoneyList', {
            params: queryParams,
            timeout: 5000
          });
          
          console.log('交易明细接口返回:', res1);
          
          if (res1 && res1.code === 200 && res1.data) {
            const records = res1.data.records || res1.data.list || res1.data.children || (Array.isArray(res1.data) ? res1.data : []);
            console.log('交易明细记录数:', records.length);
            if (records.length > 0) console.log('首条记录字段:', Object.keys(records[0]), records[0]);
            
            if (records.length > 0) {
              const parseNum = (v) => {
                if (v == null || v === '') return 0;
                if (Array.isArray(v) && v.length >= 2) return parseFloat(v[1]) || 0;
                return parseFloat(v) || 0;
              };
              
              // 新版接口：payAmount + parttimeIncome/leaderIncome
              const getOrderId = (item) => item.orderId || item.orderNumber || item.orderNo || item.outTradeNo || item.order_id;
              const isNewApiRecord = (item) =>
                Object.prototype.hasOwnProperty.call(item, 'payAmount') &&
                (Object.prototype.hasOwnProperty.call(item, 'parttimeIncome') ||
                 Object.prototype.hasOwnProperty.call(item, 'leaderIncome'));

              if (isNewApiRecord(records[0])) {
                console.log('✅ 检测到新版收入明细接口数据结构（含 payAmount / parttimeIncome / leaderIncome）');
                let idx = 0;
                orders = records.map((item) => {
                  const oid = getOrderId(item) || ('ORD' + Date.now() + (idx++));
                  const payAmount = parseNum(item.payAmount);
                  const partIncome = parseNum(item.parttimeIncome);
                  const leaderIncome = parseNum(item.leaderIncome);
                  // 单人视角下，一般只有其中一个有值，这里两者相加以兼容异常情况
                  const profit = partIncome + leaderIncome;
                  return {
                    id: item.id || idx,
                    orderId: oid,
                    type: item.type || item.orderType || '代取快递',
                    orderPrice: payAmount,      // 订单金额 = 用户实付金额
                    profit: profit,             // 收益金额 = 兼职收入 + 负责人提成
                    createTime: item.createTime || item.orderTime || new Date().toISOString(),
                    status: item.status !== undefined ? String(item.status) : '2'
                  };
                });
                hasRealData = true;
                console.log('✅ 新版接口转换完成，订单数:', orders.length);
              } else {
                // 兼容旧版逻辑
                const rowAmount = (item) => parseNum(item.orderPrice) || parseNum(item.amount) || parseNum(item.money) || parseNum(item.income) || parseNum(item.profit) || 0;
                const orderTotalMap = {};
                const orderIds = {};
                records.forEach((item) => {
                  const oid = getOrderId(item);
                  if (!oid) return;
                  if (!orderIds[oid]) orderIds[oid] = [];
                  orderIds[oid].push(item);
                });
                Object.keys(orderIds).forEach((oid) => {
                  const list = orderIds[oid];
                  const withTotal = list.find((item) => parseNum(item.orderTotalPrice) > 0);
                  orderTotalMap[oid] = withTotal ? parseNum(withTotal.orderTotalPrice) : list.reduce((sum, item) => sum + rowAmount(item), 0);
                });
                const isPlatformType = (item) => (item.type || item.orderType || '').toString().indexOf('平台提成') !== -1;
                const onlyIncomeRecords = records.filter((item) => !isPlatformType(item));
                let idx = 0;
                orders = onlyIncomeRecords.map((item) => {
                  const oid = getOrderId(item) || ('ORD' + Date.now() + (idx++));
                  const orderTotal = parseNum(item.orderTotalPrice) || orderTotalMap[oid] || rowAmount(item);
                  return {
                    id: item.id || idx,
                    orderId: item.orderId || item.orderNumber || oid,
                    type: item.type || item.orderType || '代取快递',
                    orderPrice: orderTotal,
                    profit: rowAmount(item),
                    createTime: item.createTime || item.orderTime || new Date().toISOString(),
                    status: item.status !== undefined ? String(item.status) : '2'
                  };
                });
                hasRealData = true;
                console.log('✅ 兼容旧版交易明细接口获取到真实数据');
              }
            }
          }
        } catch (e) {
          console.log('❌ 交易明细接口调用失败:', e.message);
        }
        
        // 尝试方法2: 订单列表接口（如果方法1失败）
        if (!hasRealData) {
          try {
            console.log('尝试调用订单列表接口...');
            const { data: res2 } = await this.$http.get('/campusorder/getOrderList', {
              params: {
                pageNum: 1,
                pageSize: 1000,
                jobName: row.jobName
              },
              timeout: 5000
            });
            
            console.log('订单列表接口返回:', res2);
            
            if (res2 && res2.code === 200 && res2.data) {
              const records = res2.data.records || res2.data.children || res2.data || [];
              console.log('订单记录数:', records.length);
              
              if (records.length > 0) {
                orders = records.map((item, index) => {
                  const orderPrice = parseFloat(item.totalPrice != null ? item.totalPrice : (item.orderPrice != null ? item.orderPrice : item.amount)) || 0;
                  const profit = parseFloat(item.profit != null ? item.profit : item.income) || 0;
                  return {
                    id: item.id || index + 1,
                    orderId: item.orderId || item.orderNumber || `ORD${Date.now()}${index}`,
                    type: item.orderType || item.type || '代取快递',
                    orderPrice,
                    profit,
                    createTime: item.createTime || item.orderTime || new Date().toISOString(),
                    status: item.status !== undefined ? String(item.status) : '2'
                  };
                });
                hasRealData = true;
                console.log('✅ 订单列表接口获取到真实数据');
              }
            }
          } catch (e) {
            console.log('❌ 订单列表接口调用失败:', e.message);
          }
        }
        
        // 决定使用哪个数据源
        if (hasRealData && orders.length > 0) {
          // 按时间倒序排列
          orders.sort((a, b) => new Date(b.createTime) - new Date(a.createTime));
          this.detailOrders = orders;
          console.log('✅ 使用真实数据:', orders.length + '条');
          console.log('前3条数据:', orders.slice(0, 3));
          this.$message.success(`成功加载 ${orders.length} 条真实订单记录`);
        } else {
          // 使用模拟数据
          this.detailOrders = mockData;
          console.log('⚠️ 使用模拟数据:', mockData.length + '条');
          this.$message.info(`暂无真实订单数据，显示 ${mockData.length} 条示例数据`);
        }
        
      } catch (error) {
        console.error('❌ 加载订单详情出错:', error);
        // 确保使用模拟数据
        this.detailOrders = mockData;
        this.$message.warning(`加载失败，显示 ${mockData.length} 条示例数据`);
      } finally {
        this.detailLoading = false;
        console.log('===== 订单详情加载完成 =====');
        console.log('最终 detailOrders 长度:', this.detailOrders.length);
      }
    },
    generateMockOrders(row) {
      // 生成模拟订单数据（用于演示和测试）
      console.log(`🎲 生成模拟订单数据 for ${row.jobName}, 收入: ${row.income}`);
      
      const orderTypes = ['代取快递', '万能帮', '代取外卖', '跑腿打印', '宿舍服务'];
      const mockOrders = [];
      
      // 根据收入估算订单数量（至少5条，最多30条）
      let orderCount;
      if (row.income > 0) {
        // 假设平均每单收益3元，计算订单数
        orderCount = Math.floor(row.income / 3);
        orderCount = Math.max(5, Math.min(30, orderCount));
      } else {
        orderCount = 10; // 默认10条
      }
      
      console.log(`将生成 ${orderCount} 条模拟订单`);
      
      // 计算每单的平均收益
      const avgIncome = orderCount > 0 ? row.income / orderCount : 10;
      
      for (let i = 0; i < orderCount; i++) {
        const randomFactor = 0.7 + Math.random() * 0.6;
        const profit = parseFloat((avgIncome * randomFactor).toFixed(2));
        const orderPrice = parseFloat((profit / 0.3).toFixed(2));

        const statusRandom = Math.random();
        let status;
        if (statusRandom > 0.95) status = '3';
        else if (statusRandom > 0.90) status = '0';
        else if (statusRandom > 0.80) status = '1';
        else status = '2';

        const randomDays = Math.random() * 30;
        const createTime = new Date(Date.now() - randomDays * 24 * 60 * 60 * 1000);

        mockOrders.push({
          id: `DEMO${i + 1}`,
          orderId: `${new Date().getFullYear()}${String(Math.floor(Math.random() * 10000000)).padStart(8, '0')}`,
          type: orderTypes[Math.floor(Math.random() * orderTypes.length)],
          orderPrice,
          profit,
          createTime: createTime.toISOString(),
          status,
          remark: '示例数据'
        });
      }
      
      // 按时间倒序排列
      const sortedOrders = mockOrders.sort((a, b) => new Date(b.createTime) - new Date(a.createTime));
      
      console.log(`✅ 生成完成: ${sortedOrders.length} 条订单`);
      console.log('前3条:', sortedOrders.slice(0, 3));
      
      return sortedOrders;
    },
    // 详情对话框分页 - 切换每页条数
    handleDetailSizeChange(val) {
      console.log('切换每页条数:', val);
      this.detailPageSize = val;
      this.detailPageNum = 1; // 重置到第一页
    },
    // 详情对话框分页 - 切换页码
    handleDetailPageChange(val) {
      console.log('切换页码:', val);
      this.detailPageNum = val;
    },
    showDebugInfo() {
      // 显示数据结构诊断信息
      if (this.incomeList.length === 0) {
        this.$alert('当前没有数据。请先加载数据。', '调试信息', {
          confirmButtonText: '确定'
        });
        return;
      }
      
      const sample = this.incomeList[0];
      const debugInfo = `
【数据结构诊断】

总数据条数: ${this.incomeList.length}
总收入: ${this.totalIncome.toFixed(2)}

第一条数据示例:
- 名称: ${sample.jobName}
- 学校: ${sample.schoolName}  
- 收入: ${sample.income}

完整数据结构(请查看控制台):
已在控制台打印完整的前3条数据

如果收入显示为0，请：
1. 检查控制台中"第1条原始数据完整内容"
2. 查找收入金额在哪个字段中
3. 将字段名告诉开发人员进行修复
      `.trim();
      
      console.log('===== 调试信息 =====');
      console.log('完整收入列表:', this.incomeList);
      console.log('前3条详细数据:', this.incomeList.slice(0, 3));
      
      this.$alert(debugInfo, '数据结构诊断', {
        confirmButtonText: '确定',
        type: 'info'
      });
    },
    exportDetail() {
      // 导出功能
      if (this.detailOrders.length === 0) {
        this.$message.warning('暂无数据可导出');
        return;
      }
      
      this.$message.success('导出功能开发中...');
      // TODO: 实现导出Excel功能
    }
  }
};
</script>

<style scoped>
.income-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 64px);
}

/* 页面标题 */
.page-header {
  margin-bottom: 24px;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-title i {
  color: var(--primary-color);
}

.page-subtitle {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
}

/* 统计卡片 */
.stats-row {
  margin-bottom: 24px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 194, 168, 0.08);
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 194, 168, 0.15);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: white;
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.stat-label-with-picker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
}

.stat-desc {
  font-size: 12px;
  color: var(--text-secondary);
  margin-top: 6px;
  line-height: 1.4;
  opacity: 0.9;
}

/* 表格卡片 */
.table-card {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 194, 168, 0.08);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  color: var(--text-primary);
}

.card-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.card-header i {
  color: var(--primary-color);
  margin-right: 8px;
}

.rank-tabs {
  margin-top: 4px;
}

.rank-tabs >>> .el-tabs__item.is-active {
  color: var(--primary-color);
}

.rank-tabs >>> .el-tabs__active-bar {
  background-color: var(--primary-color);
}

/* 排名徽章 */
.rank-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
}

.rank-1 {
  background: linear-gradient(135deg, #ff6b6b, #ff5252);
  color: white;
  box-shadow: 0 4px 12px rgba(255, 82, 82, 0.3);
}

.rank-2 {
  background: linear-gradient(135deg, #ffa726, #ff9800);
  color: white;
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.3);
}

.rank-3 {
  background: linear-gradient(135deg, #66bb6a, #4caf50);
  color: white;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.rank-normal {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-secondary);
}

/* 用户信息 */
.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-details {
  flex: 1;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.user-phone {
  font-size: 12px;
  color: var(--text-secondary);
}

/* 收入单元格 */
.income-cell {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.income-amount {
  font-size: 16px;
  font-weight: 700;
  color: #00C2A8;
}

.income-progress {
  width: 100%;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--text-secondary);
}

.empty-state i {
  font-size: 64px;
  color: var(--border-color);
  margin-bottom: 16px;
}

.empty-state p {
  font-size: 14px;
  margin: 0;
}

/* 详情对话框样式 */
.detail-info-card {
  margin-bottom: 0;
  border-radius: 8px;
}

.info-item {
  padding: 10px 0;
}

.info-label {
  font-size: 14px;
  color: #909399;
  display: inline-block;
  margin-right: 8px;
}

.info-value {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
}

.income-highlight {
  color: #00C2A8 !important;
  font-size: 18px !important;
  font-weight: 700 !important;
}

.detail-orders-card {
  border-radius: 8px;
}

.detail-orders-card .el-card__header {
  border-bottom: 1px solid #ebeef5;
  padding: 15px 20px;
}

/* 对话框内的空状态 */
.detail-orders-card .empty-state {
  padding: 40px 20px;
}

.detail-orders-card .empty-state i {
  font-size: 48px;
}

/* 响应式 */
@media (max-width: 768px) {
  .stat-card {
    flex-direction: column;
    text-align: center;
  }
  
  .user-info {
    flex-direction: column;
    text-align: center;
  }
  
  .info-item {
    margin-bottom: 10px;
  }
}
</style>

